document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
            console.log('style changed!', mutationRecord.target.childNodes.length)
            if (mutationRecord.target.childNodes.length > 0) {
                document.body.classList.add('sf-results-loaded')
            } else {
                document.body.classList.remove('sf-results-loaded')
            }

            if (mutationRecord.target.style.display === 'block') {
                document.body.classList.add('sf-results-open')
            } else {
                document.body.classList.remove('sf-results-open')
            }
        });
    });

    const target = document.querySelectorAll('.product-search-results-content');

    target.forEach((el) => observer.observe(el, {attributes: true, attributeFilter: ['style']}));

    // target.forEach((el) => el.observe(target, {childList: true, attributes: true, attributeFilter: ['style']}));
});